export default __webpack_public_path__ + "static/media/Picture1.666fbe0d.png";